var exports = {
  "Rs": "CopilotSidebar__s-FlK1",
  "vI": "CopilotSidebar--open__EE5gHl",
  "aT": "CopilotSidebar__header__-jEpNK",
  "X3": "CopilotSidebar__header-link__7Rzwi6",
  "Dz": "CopilotSidebar__header-button__IkX0DC",
};

module.exports = exports;
